import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WorkspacesPage } from '@/features/admin/workspaces/workspace-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « rstudio » de la navigation : les espaces de travail de ce type (revue C13). */
export const Route = createFileRoute('/$tenant/rstudio')({ component: RStudioRoute });

function RStudioRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="rstudio" crumbs={[{ label: t('nav.items.rstudio') }]}>
      <WorkspacesPage tenantId={tenant} kind="rstudio" />
    </ConsoleShell>
  );
}
